import React, { useContext, useEffect, useState } from 'react';
import User from '../components/Utils';
import MenuBar from '../components/Menubar';
import LoaderContext from '../components/LoaderContext';
import { Link } from 'react-router-dom';

type Props = {
  user: User,
  handleLogin(user: any): void
};

const ExpiredItemPage: React.FC<Props> = (props) => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [items, setItems] = useState<any[]>([]);
  const [showTable, setShowTable] = useState<boolean>(false);

  const handleNotification =  async () =>
  {
    try {
      const stored = localStorage.getItem('YoloMeal');
      console.log(stored);
      if (stored) {
        showLoader();
        const userData = JSON.parse(stored);

        fetch(
          process.env.REACT_APP_SERVER_URL +
          `/markedExpiredItem` ,
          {
            method: 'GET',
            headers: new Headers({
              'Content-Type': 'application/json',
              Accept: 'application/json',
              Authorization: 'Bearer ' + userData.token,
            })
          }
        )
          .then((items) => items.json())
          .then(
            (result) => {
              setItems(result);
              setShowTable(true);
              hideLoader();
            },
            (error) => {
              hideLoader();
              console.log(error)
            }
          );

      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  return(
    <main>
      <div className="container mypage">
        <MenuBar user={props.user} />
        <section>
          <div className="page-box-main">
{props.user.isLogged && (props.user.id === 6 || props.user.id === 7 || props.user.id === 514) &&
              <h2 className="futuralt-book pt-2 mb-4 text-center f-22">
                <button className={"see-restaurant-button"} onClick={handleNotification}>
                  Click Here for the Items that Meet the Expiry Threshold '5'
                </button>
              </h2>
            }

            {showTable && items.length > 0 && (
              <table className="shares-table" style={{ width: '152%', marginTop:'70px' }}>
                <thead>
                <tr>
                  <td><strong>Items</strong></td>
                  <td><strong>Action</strong></td>
                </tr>
                </thead>
                <tbody>
                {items.map((item: any, index) => (
                  <tr key={index}>
                    <td>{item.name}</td>
                    <td>
                      <Link to={`/itemDetails/${item.id}?name=${encodeURIComponent(item.name)}`} className='select'>Select</Link>
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            )}
          </div>
          <div className="page-box-main">
            <button className={"see-restaurant-button black justify-content-center"}>
              <Link to="/admin">Back</Link>
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default ExpiredItemPage;